import React from 'react'
import PropTypes from 'prop-types'

import ios from '../../components/developerApi/developerSdk/Documentation/IOS/DocumentationComponent'
import android from '../../components/developerApi/developerSdk/Documentation/Android/DocumentationComponent'

import './documentationLayout.scss'

const DOCUMENTATIONS = {
    ios,
    android,
    web: () => <h1>Not Implemented Yet</h1>,
}

class DocumentationLayout extends React.Component {
    render() {
        const DocumentationComponent = DOCUMENTATIONS[this.props.api]

        return <div className="documentation-layout">
            <h2>Documentation</h2>
            <DocumentationComponent />
        </div>
    }
}

DocumentationLayout.propTypes = {
    api: PropTypes.string.isRequired,
}

export default DocumentationLayout



// WEBPACK FOOTER //
// ./src/layouts/Documentation/DocumentationLayout.js